<style lang="scss" scoped>
    @import "../../../../sass/variables";

    @media (max-width: 992px) {
        /* 移动排版 */
        .cell {
            width: 94%;
            margin: 10px 2% 20px 2%;
        }
    }

    @media (min-width: 992px) {
        /* 非移动排版 */
        .cell {
            width: 206px;
            height: 258px;
            margin: 20px 8px 0 8px;
        }
    }

    .cell {
        display: inline-block;
        box-sizing: border-box;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        background: #fff;
        text-align: center;
        padding: 25px 5px 30px 5px;
    }

    .avatar {
        > img {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            overflow: hidden;
        }
    }

    .title {
        padding-left: 10%;
        padding-right: 10%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .desc {
        margin-top: 3px;
        padding-left: 10%;
        padding-right: 10%;
        font-size: 14px;
        overflow: hidden;
        line-height: 21px;
        height: 21px * 2;
    }

    .property {
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 14px;
    }

    .enter {
        margin-top: 15px;
    }
</style>

<template>
    <li class="cell">
        <div class="avatar">
            <img v-lazy="icon" alt="话题缩略图">
        </div>
        <h4 class="title">{{ title }}</h4>
        <div class="desc">
            {{ intro }}
        </div>
        <div class="property">
            <span>{{ followers }}人订阅</span> | <span>{{ articlesCount }}篇文章</span>
        </div>
        <div class="enter">
            <a class="ui basic green button mini" :href="url">进入专题</a>
        </div>
    </li>
</template>

<script>
    import 'semantic-ui-button/button.min.css';

    export default {
        props: {
            icon: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            },
            title: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            },
            intro: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            },
            followers: {
                type: Number,
                default: 0,
                required: true,
                validator: function (value) {
                    return value >= 0;
                }
            },
            articlesCount: {
                type: Number,
                default: 0,
                required: true,
                validator: function (value) {
                    return value >= 0;
                }
            },
            url: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/subject/cell.vue